import { getContext, put, takeLatest } from 'redux-saga/effects';
import { SupabaseClient } from '@supabase/supabase-js';
import { Database } from '@wix/da-papi-types/lib/supabase';
import ddt from '@wix/da-ddt';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import i18next from 'i18next';
import {
  fetchReactionUsers,
  fetchReactionUsersSuccess,
  fetchReactionUsersFailure,
} from '../../actions/message';
import { reactionUsersToPapiUsers } from '../../helpers';

function* handleFetchReactionUsers(
  action: ReturnType<typeof fetchReactionUsers>
) {
  const { messageId, emoji_id } = action.payload;
  const client: SupabaseClient<Database, 'damz'> =
    yield getContext('supaClient');

  try {
    // Call the Supabase RPC function to get users who reacted
    const response = yield client.rpc('get_reaction_users', {
      p_message_id: String(messageId),
      p_emoji_id: emoji_id,
    });

    if (response.error) {
      throw new Error(
        response.error.message || 'Failed to fetch reaction users'
      );
    }

    const supabaseUsers = response.data || [];
    // Convert Supabase results to PapiUser objects
    const users = reactionUsersToPapiUsers(supabaseUsers);

    yield put(fetchReactionUsersSuccess(messageId, emoji_id, users));
  } catch (error) {
    ddt.alert(
      'damz',
      '[damz] Failed to fetch reaction users',
      ['damz', 'db'],
      error
    );
    yield put(
      fetchReactionUsersFailure(
        messageId,
        emoji_id,
        error.message || 'Failed to fetch reaction users'
      )
    );
    yield put(
      addErrorNotification(i18next.t('damz:damz.room.reactions.fetch.error'))
    );
  }
}

/**
 * Saga for handling reaction user fetching
 */
export function* roomReactionUsersSaga() {
  yield takeLatest(fetchReactionUsers, handleFetchReactionUsers);
}
